import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: '[app-tr-part]',
  template: `
  <td class="align-middle"><img src="{{local}}{{ part?.thumbnail }}" width="34" class="me-2">{{ part?.name }}</td>
  <td class="align-middle">{{ part?.IPN }}</td>
  <td class="align-middle">{{ part?.revision}}</td>
  <td class="align-middle">{{ part?.units}}</td>
  <td class="align-middle text-center">{{ part?.description}}</td>
  <td class="align-middle text-center">{{ part?.category_name}}</td>
  <td class="align-middle text-center">{{ part?.default_location_detail?.name}}</td>
  <td class="align-middle text-center">
    <span *ngIf="part?.total_in_stock == 0" class="text-danger">Sin inventario</span>
    <span *ngIf="part?.total_in_stock != 0">{{ part?.total_in_stock}}</span>
  </td>
  <td class="align-middle">{{ part?.pricing_min | currency}} - {{ part?.pricing_max | currency}}</td>
  `,
  styleUrls: []
})
export class TrPartComponent {
  @Input() part: any;
  @Input() profile: any;
  @Input() permissions: any;

  invURL: string = environment.INV_REST_WSPREFIX;
  local: string = 'http://localhost:8000';
}
